// extracted by mini-css-extract-plugin
export default {"error":"snackbar__error___fRyke","info":"snackbar__info___oZcMP","message":"snackbar__message___TZKQd"};